import { Component, OnInit, HostBinding } from '@angular/core';
import { NgxExcelCellInterface } from '../../interfaces/ngx-excel-cell.interface';

@Component({
  selector: 'ngx-excel-cell[handleCell]',
  template: '<div class="handle"></div>'
})
export class NgxExcelHandleCellComponent extends NgxExcelCellInterface implements OnInit {

  @HostBinding('class.ngx-excel-cell--handle') excelCellHandleClass = true;

  ngOnInit() { }

}
